/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import RevisionDescriptor, { IRevision, IRevisionJSON } from '../descriptors/revisiondescriptor';
import { IRevisionObject } from '../revision';

export interface IRevisionHistoryConnectResponseJSON extends IMessage {
	channel: string;
	requestId: number;
	revisions: IRevisionJSON[];
}

export interface IRevisionHistoryConnectResponseObject {
	channel: string;
	requestId: number;
	revisions: IRevisionObject[];
}

export default class RevisionHistoryConnectResponse extends Message {
	public static readonly DESCRIPTOR_NAME: string = 'RevisionHistoryConnectResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			channel: {
				type: 'string',
				id: 1
			},
			requestId: {
				type: 'uint32',
				id: 2
			},
			revisions: {
				type: 'RevisionDescriptor',
				id: 3,
				rule: 'repeated'
			}
		}
	} ) )();

	public constructor(
		public readonly channel: string,
		public readonly requestId: number,
		public readonly revisions: IRevision[]
	) {
		super();
	}

	public toJSON(): IRevisionHistoryConnectResponseJSON {
		return {
			channel: this.channel,
			requestId: this.requestId,
			revisions: this.revisions.map( RevisionDescriptor.toJSON )
		};
	}

	/**
	 * Creates frontend revision history model from message sent from the backend.
	 *
	 * This method is intended to be used on the frontend side after receiving the response from the backend.
	 */
	public toObject(): IRevisionHistoryConnectResponseObject {
		return {
			channel: this.channel,
			requestId: this.requestId,
			revisions: this.revisions.map( RevisionDescriptor.toObject )
		};
	}

	public static fromJSON( json: IRevisionHistoryConnectResponseJSON ): RevisionHistoryConnectResponse {
		return new RevisionHistoryConnectResponse(
			json.channel,
			json.requestId,
			json.revisions.map( RevisionDescriptor.fromJSON )
		);
	}
}

